import { FC } from 'react'
import { AdFormatSubContent } from '@/components/atoms/AdFormatSubContent'
import styles from './index.module.scss'

type Props = {
  title: string
  text: string
  isImageAd?: boolean
  src: string
}

export const AdFormat: FC<Props> = ({ title, text, isImageAd = false, src }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h2 className={styles.title}>{title}</h2>
      </div>
      <div className={styles.body}>
        <div className={styles.content}>
          <div className={styles.text}>{text}</div>
          {isImageAd && <AdFormatSubContent name='Image' text='4000w x 800h (JPEG or PNG)' />}
          <AdFormatSubContent name='Pricing' text='Contact our ads team to inquire about pricing & availability' />
          <AdFormatSubContent name='Payment Method' text='USDC or Tokens of your project (listed)' />
        </div>
        <div>
          <img src={src} alt='AdFormats' className={styles.image} />
        </div>
      </div>
    </div>
  )
}
